import { BarChart } from "@mantine/charts"
import { useTranslation } from "react-i18next"
import type { IMultiAnswerProps } from "./types"
import { filterAnswersWithValue } from "./utils"

export function MultiAnswerBoolean({ answers }: IMultiAnswerProps) {
  const { t } = useTranslation()
  const answersDone = filterAnswersWithValue(answers)

  const yes = answersDone.filter((a) => !!a.value).length
  const no = answersDone.length - yes
  const yesLabel = t("Yes")
  const noLabel = t("No")
  const data = [{ [yesLabel]: yes, [noLabel]: no, label: t("Answers") }]

  return (
    <BarChart
      h={200}
      dataKey="label"
      data={data}
      series={[
        {
          name: yesLabel,
          color: "green.5",
        },
        {
          name: noLabel,
          color: "red.5",
        },
      ]}
      tickLine="none"
      gridAxis="none"
      minBarSize={10}
      withXAxis={false}
      withYAxis={false}
      withBarValueLabel
    />
  )
}
